import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import useQuote from "../../hooks/useQuote";
import useUser from "../../hooks/useUser";
import { darkMode, lightMode } from "../../lib/models/color-mode-colors";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import FormSfAccountDealSelector from "./FormSfAccountDealSelector";
import FormSubmitButton from "./FormSubmitButton";

interface FormSfActionsProps {
  handler: (action: QuoteFormActions, values: any) => void;
}

function FormSfActions({ handler }: FormSfActionsProps) {
  const [isOpen, setIsOpen] = React.useState(true);
  const quoteContext = useQuote();
  const { role, isEmployee } = useUser();
  const { state, dispatch } = quoteContext;
  const { isSubmitting, hasQuoteBeenSubmitted } = state;
  const bgColor = useColorModeValue(lightMode[100], darkMode[200]);

  const handleAccountDealUpdate = React.useCallback(
    (
      accountId: string,
      dealId: string,
      campaignId: string,
      campaignName: string,
      campaignExpirationDate: string,
      campaignIncentive: string,
      campaignCode: string
    ) => {
      dispatch({
        type: "QUOTE_SF_INFO_UPDATE",
        payload: {
          sfaccountid: accountId,
          sfdealid: dealId,
          campaignId: campaignId,
          campaignName: campaignName,
          campaignExpirationDate: campaignExpirationDate,
          campaignIncentive: campaignIncentive,
          campaignCode: campaignCode,
        },
      });
    },
    [dispatch]
  );

  return (
    <Box
      background={bgColor}
      padding={4}
      borderRadius="md"
      boxShadow="sm"
      minW={275}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Heading size="sm">Submit Actions</Heading>
        <Button
          display={{ base: "inline-flex", lg: "none" }}
          rightIcon={
            isOpen ? (
              <ChevronUpIcon height={6} width={6} />
            ) : (
              <ChevronDownIcon height={6} width={6} />
            )
          }
          onClick={() => setIsOpen(!isOpen)}
          variant="unstyled"
          size="sm"
        >
          {isOpen ? "Collapse" : "Expand"}
        </Button>
      </Flex>

      {isOpen && (
        <>
          <Divider paddingBottom={3} />
          <VStack
            width="full"
            spacing={6}
            alignItems="flex-start"
            marginTop={4}
          >
            <Box display="flex" flexDir="column" width="full">
              {isEmployee && (
                <FormSfAccountDealSelector
                  accountId={state.sfIntegration?.sfaccountid}
                  dealId={state.sfIntegration?.sfdealid}
                  campaignId={state.sfIntegration?.campaignId}
                  onAccountDealUpdate={handleAccountDealUpdate}
                  isSubmitting={isSubmitting}
                  hasSubmitted={hasQuoteBeenSubmitted}
                />
              )}
              <Box>
                <FormSubmitButton handler={handler} role={role} />
              </Box>
            </Box>
          </VStack>
        </>
      )}
    </Box>
  );
}

export default FormSfActions;
